import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import {
  DEFAULT_LANGUAGE,
  LANGUAGES,
  SUPPORTED_LANGUAGES,
} from 'utils/constants';

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    debug: false,

    detection: {
      order: ['localStorage', 'sessionStorage', 'navigator', 'htmlTag'],

      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',

      caches: ['localStorage', 'sessionStorage'],

      convertDetectedLanguage: (lng) => {
        const lowerLng = lng?.toLowerCase();

        if (lowerLng?.startsWith('en')) return LANGUAGES.EN;
        if (lowerLng?.startsWith('ro')) return LANGUAGES.RO;
        if (lowerLng?.startsWith('ru')) return LANGUAGES.RU;

        if (SUPPORTED_LANGUAGES.includes(lng)) return lng;

        return DEFAULT_LANGUAGE;
      },
    },

    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
  });

export default i18n;
